import React, { useState, useEffect } from 'react'


function PopUp({ closePopup, popupObject, initialPopupIndex,analyticsCustom }) {
    const imageRoot = 'https://www.hp.com/content/dam/sites/worldwide/apps/presence-configurator/img/';
    //const imageRoot = process.env.PUBLIC_URL +'/img/'
    const numberOfSlides = popupObject.length;
    const [currentPopUpSlide, setCurrentPopUpSlide] = useState(initialPopupIndex)
    const [startX,setStartX] = useState(0)


/////////////////////////////////////////////////////////////////////////// for scrolling on mobile
    const handleDocumentMouseDown= e => 
        {
        e.stopPropagation();
        setStartX(e.changedTouches[0].pageX)
        }
    const handleDocumentMouseUp = e => 
        {
        e.stopPropagation();
        const limit = numberOfSlides -1;
        let endX = e.changedTouches[0].pageX;
        if( Math.abs(endX - startX) >50 )
            {
            let direction = endX - startX < 0 ? 1 : -1;
            let nextSlide = parseInt(currentPopUpSlide) + direction
            if(nextSlide<0){nextSlide =0}
            if(nextSlide>= limit){nextSlide = limit}
            setCurrentPopUpSlide( nextSlide)
            }
        }
    /////////////////////////////////////////////////////////////////////////// for tuhumbnails and arrows
    useEffect(() => 
        {
        let scrollMultiplier = window.innerWidth <= 800 ? window.innerWidth : 800
        let scrollPoss = currentPopUpSlide * scrollMultiplier
        let el = document.querySelector('.popupContainer');
        el.scrollLeft = scrollPoss;
        }, [currentPopUpSlide]);

    // position thumbs and arrows only once
    useEffect(() => 
        {
        let popupContainer = document.querySelector('.popupContainer');
        let thumbs = document.querySelector('.popup-nav')
        if (!!thumbs && window.innerWidth > 800) 
                {
                let popupHalfHeight = (popupContainer.offsetHeight / 2) + 20;
                let offset = "calc(50vh + " + popupHalfHeight + "px)"
                thumbs.setAttribute("style", "top:" + offset);
                }
        }, []);

    /////////////////////////////////////////////////////////////////////////// for thumbs and arrows
    const clickThumb = function (e) 
        {
        setCurrentPopUpSlide(e.target.dataset.id)
        //analytics
        // const currentAsInt = parseInt(e.target.dataset.id)
        // let product = document.querySelector(".popupContainer .slide:nth-child("+(currentAsInt +1) +") .right h2").textContent
        // let linkID = '0'+(currentAsInt +1) +"-"+ product 
        // analyticsCustom('slide-arrow',linkID)
        }

    const clickArrow = function (e) 
        {
        const dir = parseInt(e.target.dataset.direction)
        const currentAsInt = parseInt(currentPopUpSlide)
        let nextPopUp = currentAsInt + dir;
        if (nextPopUp < 0) { nextPopUp = 0 }
        if (nextPopUp >= popupObject.length - 1) { nextPopUp = popupObject.length - 1 }
        setCurrentPopUpSlide(nextPopUp)
        //analytics
        let product = document.querySelector(".popupContainer .slide:nth-child("+(nextPopUp +1) +") .right h2").textContent
        let linkID = '0'+(nextPopUp +1)+"-"+ product 
        // analyticsCustom('slide-arrow',linkID)
        }

    const clickLink = function (e) 
        {
        let linkIDFormated = e.target.dataset.title +"-"+ e.target.textContent
        analyticsCustom('kit-summary',linkIDFormated,'')
        }


    /////////////////////////////////////////////////////////////////////////////////
    const handleClosePupop = (e) => 
        {
        e.stopPropagation();
        if (e.target.className === "curtain" || e.target.className === "close") // some times stopPropagation() does not work
            {closePopup();}
        }
    /////////////////////////////////////////////////////////////////////////////////show form popup
    const slideStyles = () => {
        const windowW = window.innerWidth
        let styles = {
            container: { justifyContent: "left", padding: "0 calc(50% - 400px)" },
            wrap: { width: (numberOfSlides * 800) + "px" },
            slide: {}
        }
        if (windowW <= 800) {
            styles.container = { justifyContent: "left", padding: "0" }
            styles.wrap = { width: (numberOfSlides * windowW) + "px" }
            styles.slide = { width: (windowW) + "px" }
        }
        return styles
    }
    ///////////////////////////////////////////////////////////////////////////////// show popup for kit or products 
    return (
        <div className="curtain" onClick={handleClosePupop} >
            <div className="popupContainer" style={slideStyles().container}>
                <div className="slide-wrap" style={slideStyles().wrap} onTouchStart={handleDocumentMouseDown} onTouchEnd={handleDocumentMouseUp}>
                    {popupObject.map((pop, index) => {
                        const isCurrent = index === parseInt(currentPopUpSlide) ? "current" : "";
                        return (
                            <div className={`slide ${isCurrent}`} key={index} data-index={index} style={slideStyles().slide} >
                                <div className="close" onClick={handleClosePupop}>
                                    <img src={`${imageRoot}icon-close.svg`} alt="close" />
                                </div>
                                <div className={`content ${pop.shopcta !== undefined ? "hasButton" : ''}`}>
                                    <div className="contentInner">
                                        <div className={`column left`}>
                                            <img src={`${imageRoot}kits/${pop.img}`} draggable="false" alt="product" />
                                        </div>
                                        <div className={`column right`}>
                                            <h2>{pop.title}</h2>
                                            <p>{pop.subcopy}</p>
                                            <p className="list">{pop.productlist}</p>
                                            <p>{pop.body}</p> 
                                            {/* for kit with link to website*/}
                                            {pop.shopcta !== undefined
                                                ? <div className="actions">
                                                    <a href={pop.shophref} target="_blank" rel="noreferrer" className="button" onClick={clickLink} data-title={pop.title}>{pop.shopcta}</a>
                                                    {
                                                    pop.datasheethref != "" 
                                                        ?  <a href={pop.datasheethref} target="_blank" rel="noreferrer" className="link" onClick={clickLink} data-title={pop.title}>{pop.datasheettxt}</a>
                                                        : <a className="disabled">{pop.datasheettxt}</a>
                                                    }  
                                                </div>
                                                : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            {/* show thumbs  if more than 1 slide is available */}
            {numberOfSlides > 1 ?
                <div className="popup-nav">
                    {popupObject.map((pop, index) => {
                        const isCurrent = index === parseInt(currentPopUpSlide) ? "current" : "";
                        return (<span key={`slide-${index}`} data-index={index} onClick={clickThumb} data-id={index} className={isCurrent}></span>);
                    })}
                </div>
                : ""}
            {/* show arrows if more than 1 slide is available */}
            {numberOfSlides > 1 ?
                <>
                    {
                    currentPopUpSlide > 0 ?
                        <div className="arrow L" onClick={clickArrow} data-direction="-1"><img src={`${imageRoot}icon-arrow.svg`} alt="arrow-Left" /> </div>
                        : ""
                    }
                    {
                    currentPopUpSlide < popupObject.length - 1 ?
                        <div className="arrow R" onClick={clickArrow} data-direction="1"><img src={`${imageRoot}icon-arrow.svg`} alt="arrow-Right" /></div>
                        : ""
                    }
                </>
                : ""
            }
        </div>
    )
}

export default PopUp
